import covenant from '../../covenant/covenant'
import specialities from '../../specialities/specialities'
import schedule from '../../schedule/schedule'
import ProfessionalProfile from '../../professional/profile'
import Favorite from '../../favorite/favorite'

export default {
  covenant,
  specialities,
  schedule,
  ProfessionalProfile,
  Favorite
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/item/resources/components.js